import { formatDistanceToNow, parseISO, format } from 'date-fns'
import fr from 'date-fns/locale/fr'
export default {
  computed: {
    $_date_locale() {
      switch (this.$i18n.locale) {
        case 'fr':
          return fr  
        case 'en':
          return null    
        default:
          return null;
      }
    }
  },
  methods: {
    $_date_format(dateString) {
      return format(parseISO(dateString), 'P', { locale: this.$_date_locale })
    },
    $_date_formatDistance(dateString) {
      return formatDistanceToNow(parseISO(dateString), { addSuffix: true, locale: this.$_date_locale })
    },
  }
}